/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import store from "./store/store";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
                {
                    path: '/',
                    redirect: '/task/all',
                },
                {
                    path: '/task/all',
                    name: 'allTasks',
                    component: () => import('./views/Tasks.vue'),
                    props:{taskList:0},
                },
                {
                    path: '/task/inConfirmation',
                    name: 'tasksInConfirmation',
                    component: () => import('./views/Tasks.vue'),
                    props:{taskList:1},
                },
                {
                    path: '/task/finished',
                    name: 'finishedTasks',
                    component: () => import('./views/Tasks.vue'),
                    props:{taskList:2},
                },
                {
                    path: '/request',
                    name: 'addRequest',
                    component: () => import('./views/AddRequest.vue'),
                    meta:{permission: 301}
                },
                {
                    path: '/projects',
                    name: 'projects',
                    component: () => import('./views/Projects.vue'),
                    meta:{permission: 201}
                },
                {
                    path: '/project/:id',
                    name: 'project',
                    component: () => import('./views/Project/Project.vue'),
                    meta:{permission: 201}
                },
                {
                  path: '/invoices',
                  name: 'invoices',
                  component: () => import('./views/Invoices.vue'),
                  meta:{permission: 101}
                },
                {
                    path: '/invoice/:id',
                    name: 'invoice',
                    component: () => import('./views/Invoices/Invoice.vue'),
                    meta:{permission: 101}
                },
            ],
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
        // =============================================================================
        // PAGES
        // =============================================================================
                {
                    path: '/login',
                    name: 'page-login',
                    component: () => import('@/views/pages/Login.vue')
                },
                {
                    path: '/register',
                    name: 'register',
                    component: () => import('@/views/pages/Register.vue')
                },
                {
                    path: '/confirmEmail/:code',
                    name: 'confirm-mail',
                    component: () => import('@/views/pages/ConfirmEmail.vue')
                },
                {
                    path: '/resetPass/:id',
                    name: 'reset-pass',
                    component: () => import('@/views/pages/ResetPassword.vue')
                },
                {
                    path: '/resetPass/',
                    name: 'reset-pass-start',
                    component: () => import('@/views/pages/RequestResetPassword.vue')
                },
                {
                    path: '/pages/error-404',
                    name: 'page-error-404',
                    component: () => import('@/views/pages/Error404.vue')
                },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg');
    if (appLoading) {
        appLoading.style.display = "none";
    }
});

router.beforeEach((to, from, next) => {

    if(to.path.includes("resetPass") || to.path.includes("register") || to.path.includes("confirmEmail")) return next();

    if (!store.getters.loggedIn && to.path !== "/login") {
        return next('/login');
    }

    if(to.meta.permission && store.getters.userData){
        if(store.getters.permissions.includes(to.meta.permission)){
            return next();
        }else{
            return next(false);
        }
    }

    next();
});

export default router
